import { queryOptions } from '@tanstack/react-query';
import { useRouteContext } from '@tanstack/react-router';
import { offerPricing } from '@ooh/contracts';
import type { EndpointDef, callEndpoint } from '@ooh/contracts';
import { offerKeys } from '../../api/queries';

export { offerKeys };

export interface WithCallWithAuth {
  callWithAuth: <TDef extends EndpointDef>(
    def: TDef,
    request: Parameters<typeof callEndpoint<TDef>>[1],
  ) => ReturnType<typeof callEndpoint<TDef>>;
}

export const offerPricingKeys = {
  /**
   * Root prefix invalidated after a price mutation. The merged table's own
   * price/discount/lineTotal values now live on `OfferUnitListItem`
   * (`offer-units` query prefix, `units-tab/api/queries.ts`), so this prefix
   * only covers the totals fetch below.
   */
  totals: (offerId: number) => ['offer-pricing-totals', offerId] as const,
} as const;

export const offerPricingQueries = {
  totals: (auth: WithCallWithAuth, offerId: number) =>
    queryOptions({
      queryKey: offerPricingKeys.totals(offerId),
      queryFn: () => auth.callWithAuth(offerPricing.totals, { offerId }),
    }),
};

export function useEffectiveAuth(auth?: WithCallWithAuth): WithCallWithAuth {
  const routeContext = useRouteContext({ from: '__root__' });
  return auth ?? (routeContext as { auth: WithCallWithAuth }).auth;
}
